import React from "react";

type props = {
  children: React.ReactNode;
};

const Container = ({ children }: props) => {
  return (
    <div className="bg-[#fcfafd] flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
      {children}
    </div>
  );
};

export default Container;